import windowMatchMedia from '../constants/windowMatchMedia';

const DEFAULTS = {
  headerNavActiveClass: 'header-navigation--active',
  mobileNavTrigger: 'data-mobile-menu-trigger',
  mobileContainer: 'header-navigation__container',
  mobileMainPanel: '[data-mobile-panel-content="Main"]',
  mobileTop: '[data-mobile-top]',
  subNavMenu: 'data-subnav-menu',
  subNavActiveClass: 'header-navigation__subnav-active',
  subNavListItem: '[data-sub-nav-list-item]',
  subNavCloseBtn: 'data-close-subnav',
  mobilePanelTrigger: 'data-mobile-panel-trigger',
  mobilePanelContent: 'data-mobile-panel-content',
  dropDownBackground: '.header-navigation__dropdown-background',
  backgroundOverlay: '.header-navigation__overlay',
  searchButton: '[data-search-button]',
  searchFormContainer: 'data-search-form-container',
  searchForm: '[data-search-form]',
  searchFormActiveClass: 'header-navigation__search-form--active',
  searchFormCloseButton: '[data-search-form-close]',
  topLevelItemActiveClass: 'header-navigation__top-level-item--active',
  activeClass: 'active',
  sectionBanner: '[data-section-banner]',
};

export default class headerNavigation {
  constructor (el, options) {
    if (!el) {
      return console.warn('Warning: HeaderNavigation Element Not Found!');
    }

    Object.assign(this.options = {}, DEFAULTS, options);
    this.el = el;
    this.subNavListItems = this.el.querySelectorAll(this.options.subNavListItem);
    this.subNavMenu = this.el.querySelector(`[${this.options.subNavMenu}]`);
    this.subNavCloseBtns = this.el.querySelectorAll(`[${this.options.subNavCloseBtn}]`);
    this.mobileNavTrigger = this.el.querySelector(`[${this.options.mobileNavTrigger}]`);
    this.mobileContainer = this.el.querySelector(`.${this.options.mobileContainer}`);
    this.mobileTop = this.el.querySelector(this.options.mobileTop);
    this.mobileMainPanel = this.el.querySelector(this.options.mobileMainPanel);
    this.backgroundOverlay = document.querySelector(this.options.backgroundOverlay);
    this.dropDownBackground = document.querySelector(this.options.dropDownBackground);
    this.sectionBanner = document.querySelector(this.options.sectionBanner);
    this.desktopSubNavListeners = [];
    this.mobilePanelOffsetSet = false;
    this.state = {
      activePanel: '',
      mobileNavOpen: false,
      desktopSubNavOpen: false,
    };
    this.init();
  }

  init() {
    this.navSetup();
    windowMatchMedia['break-2'].addListener(() => {
      this.navSetup();
    });
  }

  navSetup() {
    const isMobile = !windowMatchMedia['break-2'].matches;

    this.clearListeners();
    this.clearStyles();
    if (isMobile) {
      this.initMobileNav();
    } else {
      this.initDesktopNav();
    }
  }

  initDesktopNav() {
    this.addDesktopSubNavListeners();
    this.subNavMenuHeightResizeListener = this.addSubNavMenuHeight.bind(this);
    this.addSearchListeners('desktop');
  }

  addDesktopSubNavListeners() {
    this.subNavListItems.forEach((subNavListItem, index) => {
      const subNavIdentifier = subNavListItem.getAttribute('data-mobile-panel-trigger');
      this.desktopSubNavListeners[index] = this.toggleDesktopSubNavMenu.bind(this, subNavIdentifier);
      subNavListItem.addEventListener('click', this.desktopSubNavListeners[index]);
    });
  }

  removeDesktopSubNavListeners() {
    this.subNavListItems.forEach((subNavListItem, index) => {
      subNavListItem.removeEventListener('click', this.desktopSubNavListeners[index]);
    });
  }

  toggleDesktopSubNavMenu(subNavIdentifier) {
    const subNav = this.el.querySelector(`[${this.options.subNavMenu}="${subNavIdentifier}"]`);
    if (!subNav.classList.contains(this.options.subNavActiveClass)) {
      subNav.classList.add(this.options.subNavActiveClass);
      this.state.desktopSubNavOpen = true;
      this.closeOtherSubNavs(subNavIdentifier);
      this.toggleBodyStyle();
      this.el.classList.add(this.options.headerNavActiveClass);
      this.addOverlayListener();
      this.addSubNavMenuHeight(subNav);
      this.addSubNavMenuHeightResizeListener();
      this.toggleSubNavItemActiveClass(subNav, 'add');
    } else {
      this.closeSubNav(subNav);
      this.state.desktopSubNavOpen = false;
      this.toggleBodyStyle();
      this.el.classList.remove(this.options.headerNavActiveClass);
      this.removeSubNavMenuHeight();
      this.removeSubNavMenuHeightResizeListener();
      this.toggleSubNavItemActiveClass(subNav, 'remove');
    }
  }

  closeOtherSubNavs(excludedsubNavIdentifier) {
    const subNavs = this.el.querySelectorAll(`[${this.options.subNavMenu}]`);
    subNavs.forEach(subNav => {
      if (subNav.getAttribute(this.options.subNavMenu) !== excludedsubNavIdentifier) {
        this.closeSubNav(subNav);
      }
    });
  }

  closeSubNav(subNav) {
    subNav.classList.remove(this.options.subNavActiveClass);
    this.toggleBodyStyle();
    this.toggleSubNavItemActiveClass(subNav, 'remove');
  }

  toggleSubNavItemActiveClass(subNav, action) {
    const parentElement = subNav.parentElement;
    const trigger = parentElement.querySelector(this.options.subNavListItem);

    if (action === 'add') {
      trigger.classList.add(this.options.topLevelItemActiveClass);
    } else {
      trigger.classList.remove(this.options.topLevelItemActiveClass);
    }
  }

  removeSubNavItemActiveClass() {
    this.subNavListItems.forEach(subNavListItem => {
      if (subNavListItem.classList.contains(this.options.topLevelItemActiveClass)) {
        subNavListItem.classList.remove(this.options.topLevelItemActiveClass);
      }
    });
  }

  addOverlayListener() {
    this.backgroundOverlay.addEventListener('click', this.overlayListener.bind(this));
  }

  overlayListener() {
    this.clearStyles();
  }

  addSubNavMenuHeight(subNav) {
    requestAnimationFrame(() => {
      const headerNavBarHeight = this.el.offsetHeight;
      const subNavigationMenuHeight = subNav.offsetHeight;
      const dropDownBackgroundHeight = headerNavBarHeight + subNavigationMenuHeight;
      this.dropDownBackground.style.height = `${dropDownBackgroundHeight}px`;
    });
  }

  removeSubNavMenuHeight() {
    this.dropDownBackground.style.height = 0;
  }

  addSubNavMenuHeightResizeListener() {
    window.addEventListener('resize', this.subNavMenuHeightResizeListener);
  }

  removeSubNavMenuHeightResizeListener() {
    window.removeEventListener('resize', this.subNavMenuHeightResizeListener);
  }

  removeSubNavActiveClass() {
    const subNavMenus = this.el.querySelectorAll(`[${this.options.subNavMenu}]`);
    subNavMenus.forEach(subNav => {
      subNav.classList.remove(this.options.subNavActiveClass);
    });
  }

  addSearchListeners(screen) {
    const searchFormContainer = this.el.querySelector(`[${this.options.searchFormContainer}="${screen}"]`);
    const searchForm = searchFormContainer.querySelector(this.options.searchForm);
    const searchButton = searchFormContainer.querySelector(this.options.searchButton);
    const searchFormCloseButton = searchFormContainer.querySelector(this.options.searchFormCloseButton);

    this.searchButtonListener = this.toggleSearchFormActiveClass.bind(this, searchForm);
    searchButton.addEventListener('click', this.searchButtonListener);

    this.searchFormCloseListener = this.removeSearchFormActiveClass.bind(this, searchForm);
    searchFormCloseButton.addEventListener('click', this.searchFormCloseListener);
  }

  removeSearchListeners() {
    const searchButtons = this.el.querySelectorAll(this.options.searchButton);
    const searchFormCloseButtons = this.el.querySelectorAll(this.options.searchFormCloseButton);

    searchButtons.forEach(searchButton => {
      searchButton.removeEventListener('click', this.searchButtonListener);
    });

    searchFormCloseButtons.forEach(searchFormCloseButton => {
      searchFormCloseButton.removeEventListener('click', this.searchFormCloseListener);
    });
  }

  toggleSearchFormActiveClass(searchForm) {
    searchForm.classList.toggle(this.options.searchFormActiveClass);
    this.el.classList.add('header-navigation__search-activated');
    const searchButton = searchForm.parentElement.querySelector(this.options.searchButton);
    searchButton.classList.add('hidden');
  }

  removeSearchFormActiveClass(searchForm) {
    searchForm.classList.remove(this.options.searchFormActiveClass);
    this.el.classList.remove('header-navigation__search-activated');
    const searchButton = searchForm.parentElement.querySelector(this.options.searchButton);
    searchButton.classList.remove('hidden');
  }

  initMobileNav() {
    this.addMobileNavListeners();
    this.addSearchListeners('mobile');
  }

  addMobileNavListeners() {
    this.mobileNavHandlerListener = this.handleMobileNavClick.bind(this);

    this.mobileNavTrigger.addEventListener('click', this.mobileNavHandlerListener);
    this.mobileContainer.addEventListener('click', this.mobileNavHandlerListener);

    this.offsetMobileContainerResizeListener = this.offsetMobileContainer.bind(this);
    this.addOffsetMobileContainerResizeListener();
  }

  addOffsetMobileContainerResizeListener() {
    window.addEventListener('resize', this.offsetMobileContainerResizeListener);
  }

  removeOffsetMobileContainerResizeListener() {
    window.removeEventListener('resize', this.offsetMobileContainerResizeListener);
  }

  removeMobileNavTriggerListener() {
    this.mobileNavTrigger.removeEventListener('click', this.mobileNavHandlerListener);
    this.mobileContainer.removeEventListener('click', this.mobileNavHandlerListener);
  }

  addMobileScrollListener() {
    this.removeScrollHandler = this.handleMobileNavScroll.bind(this);

    window.addEventListener('scroll', this.removeScrollHandler);
  }

  removeMobileScrollListener() {
    window.removeEventListener('scroll', this.removeScrollHandler);
  }

  offsetMobileContainer() {
    let mobilePanelOffset = this.mobileTop.offsetHeight;

    if (this.sectionBanner) {
      mobilePanelOffset += this.sectionBanner.offsetHeight;
    }

    this.mobileContainer.style.top = `${mobilePanelOffset}px`;
    this.mobilePanelOffsetSet = true;
  }

  handleMobileNavClick(event) {
    const isMobileContainer = event.target.classList.contains(this.options.mobileContainer);
    const isMobileCloseTrigger = event.target.hasAttribute(this.options.mobileNavTrigger)
      || event.target.parentNode.hasAttribute(this.options.mobileNavTrigger);
    const isMobileNestedItem = event.target.hasAttribute(this.options.mobilePanelTrigger);

    if (isMobileNestedItem) {
      event.preventDefault();
      this.toggleMobilePanel(event.target);
      return;
    }

    if (!this.mobilePanelOffsetSet) {
      this.offsetMobileContainer();
    }

    // Check if the nav is open and if the user is clicking to close the nav
    if (this.state.mobileNavOpen && (isMobileContainer || isMobileCloseTrigger)) {
      this.toggleMobileNav();
    } else if (!this.state.mobileNavOpen) {
      this.handleMobileNavOpen();
    }
  }

  handleMobileNavScroll() {
    if (!window.pageYOffset) {
      window.requestAnimationFrame(() => {
        this.toggleMobileNav();
        this.removeMobileScrollListener();
      });
    }
  }

  handleMobileNavOpen() {
    if (!window.pageYOffset) {
      this.toggleMobileNav();
    } else {
      this.addMobileScrollListener();
      window.scroll(0, 0);
    }
  }

  toggleMobileNav() {
    this.state.mobileNavOpen = !this.state.mobileNavOpen;
    this.el.classList.toggle(this.options.headerNavActiveClass);

    // Toggle the first panel's content if the mobile nav is being opened
    if (this.state.mobileNavOpen) {
      this.toggleBodyStyle();
      this.mobileMainPanel.classList.add(this.options.activeClass);
      this.state.activePanel = this.mobileMainPanel;
    // Else reset the state of the mobile nav
    } else {
      this.clearStyles();
      this.mobileMainPanel.classList.remove(this.options.activeClass);
      this.state.activePanel = '';
    }
  }

  toggleMobilePanel(panelTrigger) {
    const activePanelId = panelTrigger.getAttribute(this.options.mobilePanelTrigger);

    this.state.activePanel.classList.remove(this.options.activeClass);
    panelTrigger.classList.remove(this.options.activeClass);
    this.state.activePanel = this.el.querySelector(`[${this.options.mobilePanelContent}="${activePanelId}"]`);
    this.state.activePanel.classList.add(this.options.activeClass);
  }

  clearListeners() {
    this.removeMobileNavTriggerListener();
    this.removeMobileScrollListener();
    this.removeDesktopSubNavListeners();
    this.removeSearchListeners();
    this.removeOffsetMobileContainerResizeListener();
    this.mobileContainer.style.top = null;
  }

  clearStyles() {
    if (this.el.classList.contains(this.options.activeClass)) {
      this.el.classList.remove(this.options.activeClass);
    }

    if (this.state.activePanel) {
      this.state.activePanel.classList.remove(this.options.activeClass);
    }

    this.removeSubNavActiveClass();
    this.el.classList.remove(this.options.headerNavActiveClass);
    this.el.classList.remove('header-navigation__search-activated');
    this.removeSubNavMenuHeight();
    this.state.mobileNavOpen = false;
    this.state.desktopSubNavOpen = false;
    this.toggleBodyStyle();
    this.removeSubNavMenuHeightResizeListener();
    this.removeSubNavItemActiveClass();
  }

  toggleBodyStyle() {
    if (this.state.mobileNavOpen || this.state.desktopSubNavOpen) {
      Object.assign(document.body.style, {
        position: 'fixed',
        height: '100%',
        width: '100%',
      });
    } else {
      Object.assign(document.body.style, {
        position: 'static',
        height: null,
        width: null,
      });
    }
  }
}
